import React from 'react';
import { LinkPlainExternal } from 'src/elements/links/Link.plain';
import IconsFacebook from 'src/images/IconsFacebook';
import IconsInstagram from 'src/images/IconsInstagram';
import IconsTwitter from 'src/images/IconsTwitter';
import IconsYoutube from 'src/images/IconsYoutube';
import IconsLinkedIn from 'src/images/IconsLinkedIn';
import { SocialLinksListContainer } from './SocialLinksList.styles';

const SocialLinksList = (): JSX.Element => {
  return (
    <SocialLinksListContainer>
      <LinkPlainExternal
        className='social-media-icon-link'
        href='https://www.youtube.com/channel/UC0kOOsZ55RofRas1uPIEZmg'
        target='_blank'
        rel='noreferrer noopener'
      >
        <span className='sr-only'>Find us on YouTube</span>
        <IconsYoutube customWidthXxs='34px' />
      </LinkPlainExternal>
      <LinkPlainExternal
        className='social-media-icon-link'
        href='https://www.instagram.com/mightynetworks/'
        target='_blank'
        rel='noreferrer noopener'
      >
        <span className='sr-only'>Find us on Instagram</span>
        <IconsInstagram customWidthXxs='23px' />
      </LinkPlainExternal>
      <LinkPlainExternal
        className='social-media-icon-link'
        href='https://www.facebook.com/mightynetworks/'
        target='_blank'
        rel='noreferrer noopener'
      >
        <span className='sr-only'>Find us on Facebook</span>
        <IconsFacebook customWidthXxs='24px' />
      </LinkPlainExternal>
      <LinkPlainExternal
        className='social-media-icon-link'
        href='https://twitter.com/mightynetworks'
        target='_blank'
        rel='noreferrer noopener'
      >
        <span className='sr-only'>Find us on Twitter</span>
        <IconsTwitter
          customWidth='22px'
          customWidthXxs='19px'
        />
      </LinkPlainExternal>
      <LinkPlainExternal
        className='social-media-icon-link'
        href='https://www.linkedin.com/company/mightynetworks/'
        target='_blank'
        rel='noreferrer noopener'
      >
        <span className='sr-only'>Find us on LinkedIn</span>
        <IconsLinkedIn customWidthXxs='24px' />
      </LinkPlainExternal>
    </SocialLinksListContainer>
  );
};

export default SocialLinksList;
